import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import { Helmet } from 'react-helmet'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'


const NotePage = (props) => {
  const { gender, meta, note, products, notes } = props

  const metadata = {
    placement: 'seo page',
  }

  return (
    <Fragment>
      <Helmet
        title={meta.title}
        meta={[
          { name: 'description', content: meta.description },
        ]}
      />
      <Media mobile>
        {
          (isMobile) =>
            React.createElement(isMobile ? Mobile : ExceptMobile, {
              gender,
              note,
              notes,
              products,
              productsAtPage: 1000,
              metadata,
            })
        }
      </Media>
    </Fragment>
  )
}

NotePage.propTypes = {
  gender: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  note: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  notes: PropTypes.array.isRequired,
}

export default NotePage
